import { EdiConfig } from './edifact-config';
import { PartnerIdentificationType } from './partner-identification-type';
import { PartnerType } from './partner-type';
import { X12Config } from './x12-config';
import { IntegratedFtpConfiguration } from './integrated-ftp-configuration';

export class Partner {

    constructor() {
        this.EdiConfig = new EdiConfig();
        this.X12Config = new X12Config();
    }
    
    PartnersId: number;
    Comment: string;
    EdiPortalId: string;
    PartnerName: string;
    EdiConfig: EdiConfig;
    MainIdentificationType: PartnerIdentificationType;
    PartnerType: PartnerType;
    X12Config: X12Config;
    IntegratedFtpConfiguration?: IntegratedFtpConfiguration;
    IsDeleted: boolean;
    IsProxyPartner: boolean;
}
